



























































































// 企业端pc模板
export default {
  name: "enterprise-enterpriseTemplate-pc",
  data() {
    return {
      checked: false,
      clock: false,
      time: 60,
      formData: {
        phone: "",
        checkNum: "",
      },
      formTest: {
        phone: false,
        code: false,
      },
    };
  },
  props: ["config"],
  computed: {
    next: function() {
      const flag =
        (this as any).checked &&
        Object.keys((this as any).formData).every(
          (key) => (this as any).formData[key]
        ) &&
        Object.keys((this as any).formTest).every(
          (key) => !(this as any).formTest[key]
        );
      return flag;
    },
  },
  watch: {
    // formData: {
    //   handler(newCul: any) {
    //     console.log(newCul, "newCul");
    //     Object.keys(newCul).every((key) => {
    //       (this as any).test(key);
    //     });
    //   },
    //   deep: true,
    // },
    config: {
      handler(newCul: any) {
        const instance = this as any;
        instance.checked = newCul.protocolStatus;
      },
      immediate: true,
    },
  },
  methods: {
    limit(key: string) {
      if (key === "phone" && (this as any).formData[key].length > 11) {
        (this as any).formData[key] = (this as any).formData[key].slice(0, 11);
      }
    },
    test(key: string) {
      if (key === "phone") {
        const phoneReg = /^[1][0-9]{10}$/;
        if (
          !(this as any).formData[key] ||
          !phoneReg.test((this as any).formData[key])
        ) {
          (this as any).formTest["phone"] = true;
        } else {
          (this as any).formTest["phone"] = false;
        }
      }
    },
    sendSms() {
      const phoneReg = /^[1][0-9]{10}$/;
      if (
        !(this as any).formData.phone ||
        !phoneReg.test((this as any).formData["phone"])
      ) {
        (this as any).formTest.phone = true;
        return;
      }
      (this as any).clock = true;
      (this as any).time = 60;
      const inter = setInterval(() => {
        (this as any).time--;
        if ((this as any).time <= 0) {
          clearInterval(inter);
          (this as any).clock = false;
        }
      }, 1000);
      const config = (this as any).config;
      const params = {
        businessType: 1,
        phone: (this as any).formData.phone,
        smsType: config.smsType,
        userType: config.userType
      };
      (this as any).$emit("send-sms", params);
    },
    nextFun() {
      if (!(this as any).next) return;
      const config = (this as any).config;
      const params = {
        account: (this as any).formData.phone,
        checkNum: (this as any).formData.checkNum,
        source: "pc",
        userType: config.userType,
        businessType: 1,
      };
      (this as any).$emit("register-handle", params);
    },
    goLogin() {
      (this as any).$emit("go-login");
    },
    goUrl(url: string) {
      window.location.href = url;
    },
  },
};
